import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import DynamicReportService from './service'

export const getTemplatesThunk = createAsyncThunk(
  'dynamicReport/GET_TEMPLATES',
  async (data, { rejectWithValue }) => {
    try {
      const response = await DynamicReportService.getTemplates(data)
      if (response.success) {
        return {
          ...response,
          data: response.data || [],
        }
      }
      return rejectWithValue(false)
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue(true)
      }
      return rejectWithValue(false)
    }
  },
)

export const deleteTemplatesThunk = createAsyncThunk(
  'dynamicReport/DELETE_TEMPLATES',
  async (data, { dispatch }) => {
    const response = await DynamicReportService.deleteTemplates(data.param)
    if (response.success) {
      dispatch(getTemplatesThunk(data.paramGet))
    }
  },
)

export const updateTemplateThunk = createAsyncThunk(
  'dynamicReport/UPDATE_TEMPLATE',
  async (data, { dispatch }) => {
    const response = await DynamicReportService.updateTemplate(data.param)
    if (response.success) {
      dispatch(getTemplatesThunk(data.paramGet))
    }
  },
)

export const uploadFileDynamic = createAsyncThunk(
  'dynamicReport/UPLOAD_FILE',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DynamicReportService.uploadFileDynamic(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)
